import i18next from 'i18next';

export interface IDropdownObject {
  label: string;
  id: number;
  value: any;
}

export const ddlYesNo: IDropdownObject[] = [
  { id: 1, label: i18next.t("Yes"), value: true },
  { id: 2, label: i18next.t("No"), value: false },
];

export const ddlHeightFeet: IDropdownObject[] = [
  { id: 1, label: i18next.t("1 foot"), value: 1 },
  { id: 2, label: i18next.t("2 feet"), value: 2 },
  { id: 3, label: i18next.t("3 feet"), value: 3 },
  { id: 4, label: i18next.t("4 feet"), value: 4 },
  { id: 5, label: i18next.t("5 feet"), value: 5 },
  { id: 6, label: i18next.t("6 feet"), value: 6 },
  { id: 7, label: i18next.t("7 feet"), value: 7 },
  { id: 8, label: i18next.t("8 feet"), value: 8 },
  { id: 9, label: i18next.t("9 feet"), value: 9 },
  { id: 10, label: i18next.t("10 feet"), value: 10 }
];

export const ddlHeightInch: IDropdownObject[] = [
  { id: 0, label: i18next.t("0 inches"), value: 0 },
  { id: 1, label: i18next.t("1 inch"), value: 1 },
  { id: 2, label: i18next.t("2 inches"), value: 2 },
  { id: 3, label: i18next.t("3 inches"), value: 3 },
  { id: 4, label: i18next.t("4 inches"), value: 4 },
  { id: 5, label: i18next.t("5 inches"), value: 5 },
  { id: 6, label: i18next.t("6 inches"), value: 6 },
  { id: 7, label: i18next.t("7 inches"), value: 7 },
  { id: 8, label: i18next.t("8 inches"), value: 8 },
  { id: 9, label: i18next.t("9 inches"), value: 9 },
  { id: 10, label: i18next.t("10 inches"), value: 10 },
  { id: 11, label: i18next.t("11 inches"), value: 11 }
];
